import { NOTE_CENTS } from '../pos/keypad';
import { euro } from '../format';
import { Button } from './ui';

/**
 * Ziffernblock für die Kasse (K6): 3 × 4 große Tasten (mindestens 64 px), ohne Systemtastatur. Zeigt nichts an und
 * kennt keinen Betrag: Die Eingabe geht als Ziffern an `onDigits`, die Auswertung (Cent, Code) liegt in `pos/keypad.ts`.
 * Ohne „00“ bleibt die Stelle links unten leer (Code-Eingabe).
 */
export function Keypad({
  onDigits,
  onBackspace,
  doubleZero = true,
  disabled = false,
}: {
  onDigits: (digits: string) => void;
  onBackspace: () => void;
  doubleZero?: boolean;
  disabled?: boolean;
}) {
  const digits = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
  return (
    <div className="keypad" role="group" aria-label="Ziffernblock">
      {digits.map((digit) => (
        <button
          key={digit}
          type="button"
          className="keypad__key"
          disabled={disabled}
          onClick={() => {
            onDigits(digit);
          }}
        >
          {digit}
        </button>
      ))}
      {doubleZero ? (
        <button
          type="button"
          className="keypad__key"
          disabled={disabled}
          onClick={() => {
            onDigits('00');
          }}
        >
          00
        </button>
      ) : (
        <span aria-hidden="true" />
      )}
      <button
        type="button"
        className="keypad__key"
        disabled={disabled}
        onClick={() => {
          onDigits('0');
        }}
      >
        0
      </button>
      <button
        type="button"
        className="keypad__key keypad__key--back"
        aria-label="Letzte Ziffer löschen"
        disabled={disabled}
        onClick={onBackspace}
      >
        <span aria-hidden="true">⌫</span>
      </button>
    </div>
  );
}

/** Tasten „+5 €“ bis „+50 €“: Scheine, die der Kunde gibt, zählen zusammen. */
export function NoteButtons({
  onAdd,
  disabled = false,
}: {
  onAdd: (cents: number) => void;
  disabled?: boolean;
}) {
  return (
    <div className="keypad__notes" role="group" aria-label="Scheine addieren">
      {NOTE_CENTS.map((cents) => (
        <Button
          key={cents}
          variant="secondary"
          disabled={disabled}
          aria-label={`${euro(cents)} addieren`}
          onClick={() => {
            onAdd(cents);
          }}
        >
          {`+${String(cents / 100)} €`}
        </Button>
      ))}
    </div>
  );
}
